import classNames from 'classnames'
import * as React from 'react'

import Icon from '../../../../../common/Icon/Icon'
import type {TestStatus} from '../../../CompareBuildsPage.types'

import styles from './TestStatusText.css'

type Props = {
  status: TestStatus | null | undefined
  muted: boolean | null | undefined
  buildNumber: string | null | undefined
}
export default function TestStatusText({status, muted, buildNumber}: Props) {
  let className
  let text

  switch (status) {
    case 'NORMAL': {
      className = styles.successStatus
      text = 'Success'
      break
    }

    case 'FAILURE': {
      className = styles.failedStatus
      text = 'Failed'
      break
    }

    default: {
      className = styles.unknownStatus
      text = status
    }
  }

  return (
    <span
      className={classNames(className, {
        [styles.muted]: muted,
      })}
      title={buildNumber != null ? `Status of build #${buildNumber}` : undefined}
    >
      {text}
      {muted === true && <Icon className={styles.icon} name="mute" />}
    </span>
  )
}
